import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRatingVeryGood(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15 11h-2V4h2v7Zm8-7.15c.55 0 1 .495 1 1.1l-.005.044L24 5v1.05c0 .143-.025.275-.07.402l-1.51 3.877c-.15.396-.505.671-.92.671H17c-.55 0-1-.495-1-1.1V4.4c0-.303.11-.578.295-.776L19.585 0l.53.578c.135.148.22.357.22.583l-.015.175-.475 2.514H23ZM3 23H0V13h3v10Zm13.375-11.05c.894 0 1.625.765 1.625 1.7l-.008.068.008.008v1.624c0 .221-.04.425-.114.62l-2.454 5.993A1.615 1.615 0 0 1 13.938 23H6.625C5.731 23 5 22.235 5 21.3v-8.5a1.7 1.7 0 0 1 .48-1.199L10.825 6l.86.893c.22.229.358.552.358.9l-.024.272-.772 3.885h5.127Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
